import React from "react";
import T from "prop-types";
import { formatHoursToHHMM } from "b2b/utils/date";

export function RendererHodinaInterval({ hodinaOd, hodinaDo }) {
  return (
    <span className="b2b-RendererHodinaInterval">
      <span className="b2b-RendererHodinaInterval-pozadavekCas b2b-RendererHodinaInterval-pozadavekCasOd">
        {formatHoursToHHMM(hodinaOd)}
      </span>
      <span className="b2b-RendererHodinaInterval-pozadavekCas b2b-RendererHodinaInterval-pozadavekCasDo">
        {formatHoursToHHMM(hodinaDo)}
      </span>
    </span>
  );
}

RendererHodinaInterval.propTypes = { hodinaOd: T.number, hodinaDo: T.number };

export default React.memo(RendererHodinaInterval);
